import { FunctionComponent } from 'react';

type ImpressumProps = {

}

export const Impressum: FunctionComponent<ImpressumProps> = (props) => {


    return (
        <div className="impressum">
            <h1>Impressum</h1>
            <div className="main">
                <div>Informationspflicht laut §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch, §63 Gewerbeordnung und Offenlegungspflicht laut §25 Mediengesetz.</div>
                <div>&nbsp;</div>
                <div>Lia Something GmbH</div>
                <div>1040 Wien</div>
                <div>Österreich</div>
                <div>Genaue addresse auf anfrage an: liasomething_gmbh@liaworks.net</div>
                <div>&nbsp;</div>
                <div>Unternehmensgegenstand: Online Galerie</div>
                <div>UID-Nummer: ATU77476508</div>
                <div>Firmenbuchnummer: FN 566447 k</div>
                <div>Firmenbuchgericht: Wien</div>
                <div>Firmensitz: 1040 Wien</div>
                <div>Tel.: Auf anfrage an: liasomething_gmbh@liaworks.net</div>
                <div>E-Mail: hello@endlessways.net</div>
                <div>&nbsp;</div>
                <div>Aufsichtsbehörde/Gewerbebehörde: Bezirkshauptmannschaft Wien</div>
                <div>Berufsbezeichnung: Online Galerie</div>
                <div>Verleihungsstaat: Österreich</div>
                <div>Geschäftsführer: Auf anfrage an: liasomething_gmbh@liaworks.net</div>
            </div>
            <div className="secondary">
                <h2>EU-Streitschlichtung</h2>
                <div>Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten (ODR-Verordnung) möchten wir Sie über die Online-Streitbeilegungsplattform (OS-Plattform) informieren.Verbraucher haben die Möglichkeit, Beschwerden an die Online Streitbeilegungsplattform der Europäischen Kommission unter https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=DE zu richten. Die dafür notwendigen Kontaktdaten finden Sie oberhalb in unserem Impressum.</div>
                <div>Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder verpflichtet sind, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</div>
                <h2>Haftung für Inhalte dieser Website</h2>
                <div>Wir entwickeln die Inhalte dieser Website ständig weiter und bemühen uns korrekte und aktuelle Informationen bereitzustellen. Leider können wir keine Haftung für die Korrektheit aller Inhalte auf dieser Website übernehmen, speziell für jene, die seitens Dritter bereitgestellt wurden. Als Diensteanbieter sind wir nicht verpflichtet, die von ihnen übermittelten oder gespeicherten Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</div>
                <div>Unsere Verpflichtungen zur Entfernung von Informationen oder zur Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen aufgrund von gerichtlichen oder behördlichen Anordnungen bleiben auch im Falle unserer Nichtverantwortlichkeit davon unberührt.</div>
                <div>Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitte wir Sie uns umgehend zu kontaktieren, damit wir die rechtswidrigen Inhalte entfernen können. Sie finden die Kontaktdaten im Impressum.</div>
                <h2>Haftung für Links auf dieser Website</h2>
                <div>Unsere Website enthält Links zu anderen Websites für deren Inhalt wir nicht verantwortlich sind. Haftung für verlinkte Websites besteht für uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten hatten und haben, uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind und wir Links sofort entfernen würden, wenn uns Rechtswidrigkeiten bekannt werden.</div>
                <div>Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitte wir Sie uns zu kontaktieren. Sie finden die Kontaktdaten im Impressum.</div>
                <h2>Urheberrechtshinweis</h2>
                <div>Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht. Bitte fragen Sie uns bevor Sie die Inhalte dieser Website verbreiten, vervielfältigen oder verwerten wie zum Beispiel auf anderen Websites erneut veröffentlichen. Falls notwendig, werden wir die unerlaubte Nutzung von Teilen der Inhalte unserer Seite rechtlich verfolgen.</div>
                <div>Sollten Sie auf dieser Webseite Inhalte finden, die das Urheberrecht verletzen, bitten wir Sie uns zu kontaktieren.</div>
                <h2>Datenschutzerklärung</h2>
                <div>Unsere Datenschutzerklärung ist <a href="/endlessways-impressum-datenschutz.pdf">hier als PDF</a> verfügbar.</div>
                <div>Quelle: Erstellt mit dem <a href="https://www.adsimple.at/impressum-generator/">Impressum Generator</a> von AdSimple</div>
            </div>
        </div>
    );
            /*
        </div>
    )*/
/*</di:v>            
</div>
    )*/


}

export default Impressum;